import { render, staticRenderFns } from "./bo-ta-pricing-deals.vue?vue&type=template&id=69638867"
import script from "./bo-ta-pricing-deals.vue?vue&type=script&lang=js"
export * from "./bo-ta-pricing-deals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports